import { render, staticRenderFns } from "./indexVacunas.vue?vue&type=template&id=25c873af&scoped=true&"
import script from "./indexVacunas.vue?vue&type=script&lang=js&"
export * from "./indexVacunas.vue?vue&type=script&lang=js&"
import style0 from "./indexVacunas.vue?vue&type=style&index=0&id=25c873af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c873af",
  null
  
)

export default component.exports